import { Trans, useTranslation } from "react-i18next";
import image_01 from '../../img/PremiumService/Banner/image_01.jpg';
import image_02 from '../../img/PremiumService/Banner/image_02.jpg';
import Button from "../Button";

const Banner = () => {
    const { t } = useTranslation();
    return (
        <section className="relative mt-[90px] xl:mt-[200px]">
            <div className="max-w-[1220px] xl:mx-auto mx-[20px] relative">
                <div className="flex md:flex-row flex-col">
                    <div className="xl:pr-[50px] md:pr-[25px] md:pb-[13px] pb-[30px] xl:w-[calc(100%-680px)] md:w-[50%] text-center md:text-left">
                        <h1 className="open-sans text-[#0C2780] font-[700] text-[28px] xl:text-[45px]">
                            <Trans
                                i18nKey="premium.banner.title"
                                components={{ span: <span className="text-[#89BDFF]" /> }}
                            />
                        </h1>
                        <Button className="mt-[40px] hidden md:flex" color="#15318D" text="#EFEFEF" />
                    </div>
                    <div className="xl:w-[680px] md:w-[50%] sm:w-[100%] w-[calc(100%+40px)] sm:ml-0 ml-[-20px]">
                        <img className="w-[100%]" src={image_02} alt='' />
                    </div>
                </div>
                <div className="flex md:flex-row flex-col-reverse xl:mt-[-50px]">
                    <div className="xl:w-[591px] md:w-[50%] hidden md:block">
                        <img className="w-[100%]" src={image_01} alt='' />
                    </div>
                    <div className="xl:pt-[110px] md:pt-[25px] pt-[30px] xl:pl-[50px] md:pl-[25px] md:w-[50%] flex flex-col justify-center">
                        <p className="open-sans sm:text-[16px] font-[300] text-[14px] text-[#0C2780]">
                            {t('premium.banner.text_01')}
                        </p>
                        <p className="open-sans sm:text-[16px] font-[300] text-[14px] text-[#0C2780] sm:mt-[15px] mt-[13px]">
                            {t('premium.banner.text_02')}
                        </p>
                        <Button className="mt-[40px] flex md:hidden" color="#15318D" text="#EFEFEF" />
                    </div>
                </div>
            </div>
        </section>
    );
};

export default Banner;
